import styled from 'styled-components';

export const ResourceListContainer = styled.div`
  margin: 24px 24px;
`;
